import { Module } from '@/types/general/ModuleType'
import { Ref } from 'vue'
import { Field } from '@/types/general/FieldType'

export function useInitials(str?: string) {
    if (str) {
        str = str.split(' ').map(word => word[0]).join('')

        return str.length > 2 ? str.substr(0, 2) : str
    }
}
export function isIntegerString(str: string) {
    const num = parseInt(str)

    return num.toString() === str
}
export function getModuleBasedOnID(id: string|number, modules: Ref<Module[]|null>): Module | null {
    let mod = null

    if(id && modules.value) {
        modules?.value?.forEach((modul: Module) => {
            if(modul.id === id) {
                mod = modul
            }
        })
    }

    return mod
}

export function getModuleFieldsBasedOnID(id: string|number, modules: Ref<Module[]|null>): Field[] | null {
    let fields = null

    if(id && modules.value) {
        modules?.value?.forEach((modul: Module) => {
            if(modul.id === id) {
                fields = modul.related_fields
            }
        })
    }

    return fields
}

export function getModuleFieldBasedOnID(mod: Module, key: number|string, modules: Ref<Module[]|null>): Field | null {
    let field = null

    if(key && mod && modules) {
        mod?.related_fields.forEach((relField: Field) => {
            if(relField.key === key) {
                field = relField
            }
        })
    }

    return field
}

// Date range boundaries are anchored in UTC (see DateRangeField), so they have to be formatted in UTC as well.
// Formatting them in the browser timezone shifts the day, e.g. 23:59:59.999Z lands on the next day in UTC+N.
export function formatUtcDate(date?: Date | null): string {
    if (!date) {
        return ''
    }

    return date.toLocaleDateString('en-GB', {
        timeZone: 'UTC',
    })
}
